export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/MaterialIcons-Regular.cff684e5.woff2";